module.exports = __webpack_public_path__ + "static/kdls-logo-61236054a82c762c469e9481b3e6d57c.svg";